import { Title, Text } from '@mantine/core';

interface PageHeaderProps {
  title: string;
  subtitle: string;
}

/**
 * PageHeader component for consistent page headers across the application
 * Displays a title (h2) and subtitle with consistent styling and spacing
 */
export function PageHeader({ title, subtitle }: Readonly<PageHeaderProps>) {
  return (
    <>
      <Title 
        order={2} 
        mb="xs"
        sx={(theme) => ({
          '@media (max-width: 768px)': {
            fontSize: theme.fontSizes.xl,
            marginBottom: theme.spacing.xs
          }
        })}
      >
        {title}
      </Title>
      <Text 
        color="dimmed" 
        mb={60}
        sx={(theme) => ({
          '@media (max-width: 768px)': {
            fontSize: theme.fontSizes.sm,
            marginBottom: theme.spacing.xl,
            paddingLeft: theme.spacing.sm,
            paddingRight: theme.spacing.sm
          }
        })}
      >
        {subtitle}
      </Text>
    </>
  );
} 